import React, { useEffect, useState, useRef } from 'react';
import './solutions/Solutions.css'; // you can style it here
import { getDocs, collection } from 'firebase/firestore';
import { db } from '../firebase'; // adjust based on your structure

// AI
// Data Center
// Central Office & Headend
// Outside plant
// FTTx & MDU
// Rural Broadband
// Wireless
// Enterprise
// Medical Imaging
// Neuroscience
// Optoelectronics
// Specialty Optics
// Optical Equipment

const slides = [
  {
    video: "/videos/aboutHeader.mp4",
    poster: "/videos/aboutHeader.jpg",
    heading: "A Vision to Bring Light to Life",
    subheading: "Where modern networks converge and tomorrow’s service delivery begins.",
    buttonLink: "https://www.youtube.com/watch?v=tbUjpfa86FY"
  }
];

const slides2 = [
  {
    year: '1918',
    title: 'First Glass',
    description:
      'America Japan Sheet Glass Company established in Osaka, Japan as a joint venture between Libbey-Owens-Ford Glass Company in US and Sumitomo in Japan, to produce flat glass using the Colburn process.',
  },
  {
    year: '1931',
    title: 'Name Change',
    description:
      'Name changed to Nippon Sheet Glass Company, Limited, now NSG Group.',
  },
  {
    year: '1968',
    title: 'Gradient Index',
    description:
      'A Gradient Index (GRIN) distribution in a glass rod successfully achieved first time in the world by NSG through developing advanced glass chemistries and defining new manufacturing processes.',
  },
  {
    year: '1978',
    title: 'SELFOC',
    description:
      'SELFOC® trademark registered by NSG for its GRIN lens products. Unlike conventional optics which manipulate light via curved surfaces, the SELFOC lens focuses light and transmits images via a simple, flat surface.',
  },
  {
    year: '1980',
    title: 'Market Leader',
    description:
      'NSG America incorporated in US to sell SELFOC Micro Lenses in North America. NSG America becomes the undisputed market leader and the preeminent global microlens supplier.',
  },
  {
    year: '1987',
    title: 'Worldwide Growth',
    description:
      'NSG Europe established to spread worldwide sales of the SELFOC Micro Lens.',
  },
  {
    year: '1996',
    title: 'Philippines Plant',
    description:
      'NSG Philippines established. A large ISO-certified facility opens in Laguna, Philippines.',
  },
  {
    year: '1999',
    title: 'EPITAXX Sold',
    description:
      'EPITAX, a wholly-owned subsidiary of NSG, sold to JDS Uniphase. NSG maintains its III-V semiconductor capability.',
  },
  {
    year: '2004',
    title: 'Original Opti-Sourcing',
    description:
      'Opti-Sourcing services introduced by NSG America to assist customers with optical component development.',
  },
  {
    year: '2005',
    title: 'PD/APD Re-Developed',
    description:
      'NSG re-develops photodiodes and avalanche photodiodes as part of its III-V toolbox.',
  },
  {
    year: '2006',
    title: 'Pilkington Acquisition',
    description:
      'NSG acquires Pilkington Plc. in the UK, becoming one of the top two sheet glass companies globally.',
  },
  {
    year: '2009',
    title: 'Go!Foton Born',
    description:
      'Go!Foton Group formed after a successful management buyout of NSG Telecommunication Device business.',
  },
  {
    year: '2015',
    title: 'PEACOC®',
    description:
      'Go!Foton introduces PEACOC® fiber management for high-density, spreadable fiber access.',
  },
  {
    year: '2021',
    title: 'CHT',
    description:
      'Launch of Clamshell Hardened Terminal (CHT) for Go!Foton’s hardened OSP product line.',
  },
  {
    year: '2024',
    title: 'Go!Foton updates Branding',
    description:
      'Read about the engineering of our logo, look, feel, and messaging.',
  },
  {
    year: '2025',
    title: 'EKO®',
    description:
      'First successful FOA of EKO’s intelligent Layer 1 fiber monitoring for a Tier 1 network.',
  },
  {
    year: 'Today',
    title: '',
    description:
      'Go!Foton is a leading provider of photonics and optical communication technologies for industries like medical, biotech, and defense.',
  },
];

function About() {

  const [products, setProducts] = useState([]);
const [filteredProducts, setFilteredProducts] = useState([]);
const [activeFilter, setActiveFilter] = useState('All');


const productFamilies = [
  'Fiber Cable Assemblies',
  'Passive Optical Components',
  'Cassettes',
  'Fiber Panels',
  'Frames',
];

const facts = [
    { label: "Years of in-house manufacturing", value: 25, prefix: "", suffix: "+", key: "years" },
    { label: "Continents with operations", value: 3, prefix: "", suffix: "", key: "continents" },
    { label: "employees dedicated to your needs", value: 2000, prefix: "~", suffix: "", key: "employees" },
    { label: "on-time delivery", value: 95, prefix: ">", suffix: "%", key: "delivery" },
  ];

  const [counts, setCounts] = useState({
    years: 0,
    continents: 0,
    employees: 0,
    delivery: 0,
  });

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener("resize", handleResize);
    console.log('isMobile?', isMobile)
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const animationFrames = {};
    const durations = 600; // in ms

    facts.forEach(fact => {
      const start = performance.now();

      const animate = now => {
        const progress = Math.min((now - start) / durations, 1);
        const currentValue = Math.floor(progress * fact.value);

        setCounts(prev => ({
          ...prev,
          [fact.key]: currentValue,
        }));

        if (progress < 1) {
          animationFrames[fact.key] = requestAnimationFrame(animate);
        }
      };

      animationFrames[fact.key] = requestAnimationFrame(animate);
    });

    return () => {
      Object.values(animationFrames).forEach(cancelAnimationFrame);
    };
  }, []);

  const [industryFilter, setIndustryFilter] = useState('Central Office & Headends')

useEffect(() => {
  const loadProducts = async () => {
    const querySnapshot = await getDocs(collection(db, 'products'));
    const allProducts = querySnapshot.docs
      .map(doc => ({ id: doc.id, ...doc.data() }))
      .filter(p => (p["Include Y or N"] || '').trim().toUpperCase() !== 'N');

    setProducts(allProducts);
    setFilteredProducts(allProducts); // Default to all
  };

  loadProducts();
}, []);

const [cardsPerView, setCardsPerView] = useState(3)
  const [current, setCurrent] = useState(0);
  const maxIndex = Math.max(0, slides2.length - cardsPerView);

  // responsive: 1 card on small screens
  useEffect(() => {
    const setByWidth = () => setCardsPerView(window.innerWidth < 768 ? 1 : 3);
    setByWidth();
    window.addEventListener("resize", setByWidth);
    return () => window.removeEventListener("resize", setByWidth);
  }, []);

  const goPrev = () => setCurrent((i) => Math.max(0, i - 1));
  const goNext = () => setCurrent((i) => Math.min(maxIndex, i + 1));
  const goTo   = (i) => setCurrent(Math.min(Math.max(i, 0), maxIndex));


const [currentSlide, setCurrentSlide] = useState(0);
const autoSlideRef = useRef(null);



useEffect(() => {
  if (activeFilter === 'All') {
    setFilteredProducts(products);
  } else {
    setFilteredProducts(products.filter(p => p.productFamily === activeFilter));
  }
}, [activeFilter, products]);

  return (
    <div className="contact-page">
      <div className="single-marquee">
        <div className="single-marquee-slide">
          <video
          disablePictureInPicture controlsList="nodownload nofullscreen noremoteplayback"
            src={slides[0].video}
            poster={slides[0].poster}
            autoPlay
            loop
            muted
            playsInline

          />
          <div className="single-overlay-content">
            <h1>{slides[0].heading}</h1>
            <p>{slides[0].subheading}</p>
            <a href={slides[0].buttonLink} target="_blank" className="single-cta-button">
              Learn More
            </a>
          </div>
        </div>
      </div>

<svg
  className="about-section-divider"
  viewBox="0 0 1440 150"
  preserveAspectRatio="none"
>
  <path
    d="M0,0 Q720,75 1440,0 L1440,150 L0,150 Z"
    fill="#ffffff"
  />
</svg>

      <div className="solutions-section-centeredText" style={{marginTop: 20, marginBottom: 50, }}>
        <div className="solutions-section-centeredText-text-container">
          <h2 className="solutions-section-centeredText-subheading">Inspired by nature, driven by science</h2>
          <p className="solution-section-centeredText-description">Based in the USA with teams around the world, we’re at the forefront of advanced optical and photonics innovation. We engineer solutions to enhance user experience by offering customers unique approaches to solve real-world problems in connectivity, imaging, and beyond.​<br/><br/>Go!Foton technology stands apart with feature-rich and performance-optimized solutions. We keep our customers satisfied and businesses performing, ensuring new and improved ​experiences for all.​<br/><br/>Inspired by nature and physics, the sky is the limit when imagining what’s possible and creating what’s next. ​</p>
        </div>
      </div>

      <div className="solutions-section-imageBackground" style={{
    position: "relative",
    backgroundPosition: isMobile ? "center 0px" : "center -103px",
  }}>
        <div className="curved-divider-top" />
        <div className="solutions-section-imageBackground-text-container">
          <h2 className="solutions-section-imageBackground-subheading">Our Mission</h2>
          <p className="solution-section-imageBackground-description">Driving customer value with innovations inspired by nature and science ​</p>
        </div>
        {!isMobile && (<div className="curved-divider-bottom" />)}
      </div>

      <div className="solutions-section-iconGrid">
        <div className="solutions-section-iconGrid-text-container">
          <h2 className="solutions-section-iconGrid-subheading">100+ Years developing for you</h2>
          <p className="solution-section-iconGrid-description">At Go!Foton, we’re driven to solve complex business challenges through innovative optical and photonic solutions that give our customers a competitive edge. With a global reach and a vision inspired by the beauty of nature, we create cutting-edge technologies that revolutionize industries and bring light to life.​​ ​</p>
        </div>

        <div className="solutions-icon-grid-about">
            <div className="icon-item">
              <img src="https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/icons%2Fglobal.png?alt=media&token=9bd93b1c-a03c-4402-8d2b-77a39cb0602c" alt="Icon 1" />
              <p>Global facilities: USA, Japan, Philippines, China & Netherlands​</p>
            </div>
            <div className="icon-item">
              <img src="https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/icons%2Fcompliant.png?alt=media&token=31e857b2-13bd-46af-b795-a1b6b429600a" alt="Icon 2" />
              <p>US based HQ​<br />BEAD & BABA Compliant​</p>
            </div>
            <div className="icon-item">
              <img src="https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/icons%2Finnovation.png?alt=media&token=a195327c-4150-418a-a32c-5201146286c7" alt="Icon 3" />
              <p>Innovative solutions with a strong IP portfolio​</p>
            </div>
            <div className="icon-item">
              <img src="https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/icons%2Fmanufacturing.png?alt=media&token=9dc69fb4-b52a-4388-9992-f15d49a8dc7e" alt="Icon 4" />
              <p>Original designs and manufacturing for Tier 1 customers​</p>
            </div>
            <div className="icon-item">
              <img src="https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/icons%2Fcustom.png?alt=media&token=17a5a879-cf71-4e06-bd21-051b4dc59889" alt="Icon 5" />
              <p>Agile, customized design to volume manufacturing process​</p>
            </div>
            <div className="icon-item">
              <img src="https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/icons%2F%20high-volume.png?alt=media&token=e1f96276-1de7-45da-a870-510c7ae10f07" alt="Icon 6" />
              <p>Verizon & Telcordia certified, high-quality & high-volume manufacturing​</p>
            </div>
          </div>
      </div>

      <div className="solutions-section-iconGrid" style={{ marginTop: -50}}>
        <div className="solutions-section-iconGrid-text-container">
          <h2 className="solutions-section-iconGrid-subheading">Our cornerstones underpin your experience</h2>
          <p className="solution-section-iconGrid-description">When choosing Go!Foton, trust we’ll put you first, care about your experience, ensure our interests are aligned as we innovate via the right dimension, making data-backed decisions that deliver results. ​.​​ ​</p>
        </div>
      </div>

            <div className="values-grid" style={{ marginTop: -55, marginBottom: 50, marginLeft: '10vw', marginRight: '10vw'}}>
                {[
                {
                    front: "People first, integrity centered",
                    back: "Great things happen when we support one another’s strengths to solve problems.",
                    image: "/images/title1.jpg",
                },
                {
                    front: "Innovation via the right dimension",
                    back: "We aim to understand your point of view and create solutions that bring you value.",
                    image: "/images/title2.jpg",
                },
                {
                    front: "Customer experience",
                    back: "Our goal is to delight. That’s why our customers turn to us again and again.",
                    image: "/images/title3.jpg",
                },
                {
                    front: "Data-supported decision making",
                    back: "Make the best decision by considering all available information and needs.",
                    image: "/images/title4.jpeg",
                },
                {
                    front: "Interest alignment",
                    back: "Let’s win together. The best outcomes are achieved when everyone involved benefits.",
                    image: "/images/title5.jpg",
                },
                {
                    front: "Results delivered",
                    back: "We set aggressive objectives because we dare to be the best and we’re driven to achieve.",
                    image: "/images/title6.jpeg",
                },
                ].map((tile, idx) => (
                <div className="flip-card" key={idx}>
                    <div className="flip-card-inner">
                    <div className="flip-card-front">
                        <img src={tile.image} alt={tile.front} />
                        <div className="tile-caption">{tile.front}</div>
                    </div>
                    <div className="flip-card-back">
                        <p>{tile.back}</p>
                    </div>
                    </div>
                </div>
                ))}
            </div>


        
      <div className="solutions-section-imageBackground-2 simin-quote-section"  style={{ position: 'relative'}}>
        
          <div className="curved-divider-top" />

        <div className="solutions-section-imageBackground-2-text-container">
          <h2 className="solutions-section-imageBackground-2-subheading">“The sky is the limit when imagining what’s possible and creating what’s next.”</h2>
          <p className="solution-section-imageBackground-2-description">Simin Cai, President & CEO​</p>
        </div>

        <div className="curved-divider-bottom"></div>

      </div>

      <div className="solutions-section-1" style={{ marginTop: 50}}>
        <div className="solutions-section-1-image-container">
          <img src="/images/aboutPage.png" alt="Central Office" />
        </div>

        <div className="solutions-section-1-text-container">
          <h2 className="solutions-section-1-subheading">The inspiration and engineering of our brand</h2>
          <p className="solution-section-1-description"  style={{ marginBottom: 30}} >Like Go!Foton products, our brand is meticulously engineered to show the world who we are. Like a fingerprint, it is uniquely us. In 2024, we took a fresh look at our brand. The result, a harmonization of our company’s ambition, culture, and competencies expressed in how we look, speak, think, and act.<br/><br/>Read our blog for insights on the inspiration and engineering of the Go!Foton brand.</p>
          <a href={'/decoding-the-gofoton-brand'} target='_blank'  className="cta-button">View</a>
        </div>
      </div>

        <div className="solutions-section-iconGrid">
        <div className="solutions-section-iconGrid-text-container">
          <h2 className="solutions-section-iconGrid-subheading">A commitment to advancing photonics and optics</h2>
          <p className="solution-section-iconGrid-description">More than a manufacturer, Go!Foton is revolutionizing photonics and optics by providing modern alternatives to conventional solutions. These technologies enhance nearly every aspect of life. So, we’re determined to innovate to enhance performance and usability, as our solutions help enable more discoveries in communications, medical imaging, and more.</p>
        </div>
      </div>


            {/* <div className="values-grid" style={{ marginTop: -55, marginBottom: 50}}>
                {[
                {
                    front: "People first, integrity centered",
                    back: "Great things happen when we support one another’s strengths to solve problems.",
                    image: "/images/title1.jpg",
                },
                {
                    front: "Innovation via the right dimension",
                    back: "We aim to understand your point of view and create solutions that bring you value.",
                    image: "/images/title2.jpg",
                },
                {
                    front: "Customer experience",
                    back: "Our goal is to delight. That’s why our customers turn to us again and again.",
                    image: "/images/title3.jpg",
                },
                ].map((tile, idx) => (
                <div className="flip-card" key={idx}>
                    <div className="flip-card-inner">
                    <div className="flip-card-front">
                        <img src={tile.image} alt={tile.front} />
                        <div className="tile-caption">{tile.front}</div>
                    </div>
                    <div className="flip-card-back">
                        <p>{tile.back}</p>
                    </div>
                    </div>
                </div>
                ))}
            </div> */}

      <div className="solutions-section-centeredText">
        <div className="solutions-section-centeredText-text-container">
          <h2 className="solutions-section-centeredText-subheading">Driven by your needs, delivered by our innovation</h2>
          <p className="solution-section-centeredText-description">Go!Foton’s with you every step of the way. From listening to your challenges, to imagining a solution, designing, building, delivering, and supporting it, we’re here. Our optical expertise spans decades of excellence in design, engineering, and supply chain, employing some of the brightest minds in the industry. And Go!Foton is trusted and certified by the industry’s most esteemed global authorities.</p>
        </div>
      </div>

   <div className="certification-logo-slider">
  <div className="slider-track">
    {/* TL9000 */}
    <a href="https://www.tl9000.org/" target="_blank" rel="noopener noreferrer">
      <img src="/images/certificationLogos/tl9000.jpeg" alt="TL9000" />
    </a>
    {/* Ecovadis */}
    <a href="https://ecovadis.com/" target="_blank" rel="noopener noreferrer">
      <img src="/images/certificationLogos/ecovadis-vector-logo.png" alt="Ecovadis" />
    </a>
    {/* RoHS */}
    <a href="https://www.echa.europa.eu/" target="_blank" rel="noopener noreferrer">
      <img src="/images/certificationLogos/RoHS-Compliant.jpg" alt="RoHS" />
    </a>
    {/* ISO 45001 */}
    <a href="https://www.iso.org/standard/63787" target="_blank" rel="noopener noreferrer">
      <img src="/images/certificationLogos/ISO-45001-Certification.webp" alt="ISO 45001" />
    </a>
    {/* TUV NORD */}
    <a href="https://www.tuev-nord-group.com/en" target="_blank" rel="noopener noreferrer">
      <img src="/images/certificationLogos/TUEV-Logo-care-vision-1.png" alt="TUV" />
    </a>
    {/* OHSAS */}
    <a href="https://www.iso.org/standard/63787.html" target="_blank" rel="noopener noreferrer">
      <img src="/images/certificationLogos/ohshah.png" alt="OHSAS" />
    </a>
    {/* SAI SA 8000 */}
    <a href="https://sa-intl.org/programs/sa8000/" target="_blank" rel="noopener noreferrer">
      <img src="/images/certificationLogos/sinovoltaics_sa-8000-2-125x125-1.png" alt="SA8000" />
    </a>
    {/* ISO 9001 */}
    <a href="https://www.iso.org/standard/62085.html" target="_blank" rel="noopener noreferrer">
      <img src="/images/certificationLogos/iso-9001-certification.png" alt="ISO 9001" />
    </a>
    {/* Responsible Business Alliance */}
    <a href="https://www.responsiblebusiness.org/" target="_blank" rel="noopener noreferrer">
      <img src="/images/certificationLogos/RBA_lgoo.jpg" alt="RBA" />
    </a>

    {/* */}
    <a href="https://www.tl9000.org/" target="_blank" rel="noopener noreferrer">
      <img src="/images/certificationLogos/tl9000.jpeg" alt="TL9000" />
    </a>
    <a href="https://ecovadis.com/" target="_blank" rel="noopener noreferrer">
      <img src="/images/certificationLogos/ecovadis-vector-logo.png" alt="Ecovadis" />
    </a>
    <a href="https://www.echa.europa.eu/" target="_blank" rel="noopener noreferrer">
      <img src="/images/certificationLogos/RoHS-Compliant.jpg" alt="RoHS" />
    </a>
    <a href="https://www.iso.org/standard/63787.html" target="_blank" rel="noopener noreferrer">
      <img src="/images/certificationLogos/ISO-45001-Certification.webp" alt="ISO 45001" />
    </a>
    <a href="https://www.tuev-nord-group.com/en" target="_blank" rel="noopener noreferrer">
      <img src="/images/certificationLogos/TUEV-Logo-care-vision-1.png" alt="TUV" />
    </a>
    <a href="https://www.iso.org/standard/63787.html" target="_blank" rel="noopener noreferrer">
      <img src="/images/certificationLogos/ohshah.png" alt="OHSAS" />
    </a>
    <a href="https://sa-intl.org/programs/sa8000" target="_blank" rel="noopener noreferrer">
      <img src="/images/certificationLogos/sinovoltaics_sa-8000-2-125x125-1.png" alt="SA8000" />
    </a>
    <a href="https://www.iso.org/standard/62085.html" target="_blank" rel="noopener noreferrer">
      <img src="/images/certificationLogos/iso-9001-certification.png" alt="ISO 9001" />
    </a>
    <a href="https://www.responsiblebusiness.org/" target="_blank" rel="noopener noreferrer">
      <img src="/images/certificationLogos/RBA_lgoo.jpg" alt="RBA" />
    </a>
  </div>
</div>

    <div className="solutions-section-centeredText" style={{ marginTop: 50 }}>
        <div className="solutions-section-centeredText-text-container">
          <h2 className="solutions-section-centeredText-subheading">Factory Facts</h2>
          <div className="factory-facts about-factory-facts">
                {facts.map(fact => (
                  <div className="fact" key={fact.key}>
                    <div className="fact-number" style={{ color: "#85246D" }}>
                      {fact.prefix}{counts[fact.key]}{fact.suffix}
                    </div>
                    <div className="fact-label">{fact.label}</div>
                  </div>
                ))}
              </div>
        </div>
      </div>
<section className="milestones-carousel">
      <h2 className="milestones-title">Milestones in our history</h2>

      <div className="milestones-wrapper">
        <button
          className="milestones-arrow milestones-arrow--prev"
          onClick={goPrev}
          aria-label="Previous"
          disabled={current === 0}
        >
          ‹
        </button>

        <div className="milestones-viewport">
          <div
            className="milestones-track"
            style={{
              // use a CSS var for card count to keep calc consistent
              "--cards": cardsPerView,
              transform: `translateX(-${(100 / cardsPerView) * current}%)`,
            }}
          >
            {slides2.map((s, idx) => (
              <article className="milestones-card" key={idx}>
                <h3 className="milestones-year">{s.year}</h3>
                {s.title && (
                  <h4 className="milestones-cardTitle">
                    <em>{s.title}</em>
                  </h4>
                )}
                <p className="milestones-desc">{s.description}</p>
              </article>
            ))}
          </div>
        </div>

        <button
          className="milestones-arrow milestones-arrow--next"
          onClick={goNext}
          aria-label="Next"
          disabled={current === maxIndex}
        >
          ›
        </button>
      </div>

      <div className="milestones-dots">
        {Array.from({ length: maxIndex + 1 }).map((_, i) => (
          <span
            key={i}
            className={`milestones-dot ${i === current ? "is-active" : ""}`}
            onClick={() => goTo(i)}
          />
        ))}
      </div>
    </section>


      <div className="solutions-section-centeredText">
        <div className="solutions-section-centeredText-text-container">
          <h2 className="solutions-section-centeredText-subheading">Your one-stop-shop access to our global network</h2>
          <p className="solution-section-centeredText-description">With offices on 3 continents and thousands of employees worldwide, Go!Foton is the photonics industry’s leading innovator — offering a vast, global network of resources and services. By leveraging our technical knowledge, research and development expertise and manufacturing leadership, we can deliver value-added products and services at any stage of the development cycle.</p>
          <div style={{ textAlign: 'center' }}>
            <img 
              src="https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/stockImages%2Fmap.jpg?alt=media&token=83adf90e-20fb-4fa3-b84b-a01491497782" 
              alt="GoFoton Map" 
              style={{ width: '80%', maxWidth: '1200px', height: 'auto', display: 'inline-block', marginTop: 40 }} 
            />
          </div>

        </div>
      </div>


        <div className="curved-footer-solutions">
        <div className="curved-top-overlay"></div>
        
        <h2>Would you like to hear more?</h2>
        <p>Our experts would love to hear about your systems and how we can help</p>
        <a className="connect-button" href="/support">LET’S CONNECT</a>
        </div>

    </div>

    
  );
}

export default About;
